export interface ChatEvent {
  id: string;
  afterCount: number;
}

export const groupChatEvents = <E extends ChatEvent>(
  events: E[],
  itemCount: number
): Map<number, E[]> => {
  const groups = new Map<number, E[]>();
  for (const event of events) {
    const at = Math.max(0, Math.min(event.afterCount, itemCount));
    groups.set(at, [...(groups.get(at) ?? []), event]);
  }
  return groups;
};
